import { api, ApiError } from "@/lib/api";

let installed = false;

interface Payload {
  message: string;
  stack?: string;
  url?: string;
  line?: number;
  column?: number;
  userAgent?: string;
  kind: "error" | "unhandled_rejection";
}

async function post(payload: Payload): Promise<void> {
  try {
    await api.post("/api/errors", payload);
  } catch (err) {
    // Don't recurse: a failed error report swallows itself. 401 (no session
    // yet) and 429 (rate-limited) are both acceptable — keep the console log.
    if (!(err instanceof ApiError)) console.warn("[errorReporter] post failed", err);
  }
}

export function installErrorReporter(): void {
  if (installed || typeof window === "undefined") return;
  installed = true;

  window.addEventListener("error", (event) => {
    if (!event.message) return;
    void post({
      kind: "error",
      message: event.message,
      stack: event.error instanceof Error ? event.error.stack : undefined,
      url: event.filename || window.location.href,
      line: event.lineno,
      column: event.colno,
      userAgent: navigator.userAgent,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const r = event.reason as unknown;
    const message =
      r instanceof Error
        ? r.message
        : typeof r === "string"
          ? r
          : (() => {
              try {
                return JSON.stringify(r);
              } catch {
                return String(r);
              }
            })();
    void post({
      kind: "unhandled_rejection",
      message: message.slice(0, 400),
      stack: r instanceof Error ? r.stack : undefined,
      url: window.location.href,
      userAgent: navigator.userAgent,
    });
  });
}
